export class LoadDataCollectionsForced {
    public static readonly type = '[DataCollection] Load data collections forced';
}
